<template>
  <b-overlay :show="showOverlay">
    <validation-observer ref="updateNetworkRef" tag="div">
      <b-card>
        <strong>Update Wallet Network</strong>
<!--Input Fields -->
        <b-form class="my-1">
          <b-row>
            <!-- Field: name -->
            <b-col
                cols="12"
                md="4"
            >
              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <b-form-group
                    label="Network Name"
                >

                  <b-form-input
                      v-model="data.name"
                      :state="errors.length > 0 ? false:null"
                  />
                </b-form-group>

              </validation-provider>
            </b-col>

            <!-- Field:  symbol -->
            <b-col
                cols="12"
                md="4"
            >
              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >

                <b-form-group
                    label="Symbol"
                >
                  <b-form-input
                      id="symbol"
                      v-model="data.symbol"
                      :state="errors.length > 0 ? false:null"
                  />
                </b-form-group>

              </validation-provider>
            </b-col>

            <!-- Field:  Network Status -->
            <b-col
                cols="12"
                md="4"
            >
              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >

                <b-form-group
                    label="Network Status"
                >
                  <v-select
                      v-model="data.isActive"
                      :clearable="false"
                      :options="networkStatuses"
                      input-id="network-status"
                      :reduce="name => name.value"
                      label="name"
                      :state="errors.length > 0 ? false:null"
                  />
                </b-form-group>

              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
<!-- Action Buttons -->
        <b-button
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            variant="primary"
            @click="updateWalletNetwork"
        >
          Update
        </b-button>

      </b-card>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCardHeader,
  BCardTitle,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BMedia,
  BOverlay,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import MediaHandler from '@/views/components/utilities/MediaHandler.vue'
import { required } from '@validations'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Helper from '@/libs/Helper'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {UpdateWalletNetwork, GetSingleWalletNetworks} from '@/libs/Api/Networks'


export default {
  title: 'Update Wallet Network',

  data() {
    return {
      required,
      networkStatuses: [
        {
          name: 'Active',
          value: true
        },
        {
          name: 'InActive',
          value: false
        },
      ],
      data: {
        name: null,
        symbol: null,
        isActive: null,
        id:this.$route.params.id
      },
      showOverlay: false,
    }
  },


  async created() {
    await this.getSingleWalletNetwork()
  },


  methods: {
    async getSingleWalletNetwork() {
      let _this = this

      let singleWalletNetwork = new GetSingleWalletNetworks(_this)
      singleWalletNetwork.setId(_this.$route.params.id)

      await singleWalletNetwork.fetch(function (content) {
        _this.data.name = content.data.name
        _this.data.symbol = content.data.symbol
        _this.data.isActive = content.data.isActive
      }, function (error) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: error.message,
            title: `error`,
            variant: 'danger',
          },
        })
      })
    },


    async updateWalletNetwork() {
      let _this = this
      Helper.validateForm(_this, 'updateNetworkRef', async () => {
        _this.showOverlay = true
        let updateWalletNetwork = new UpdateWalletNetwork(_this)

        updateWalletNetwork.setPayload(_this.data)
        updateWalletNetwork.setParams({id: _this.$route.params.id})

        await updateWalletNetwork.fetch(function (content) {
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: `success`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `Wallet Network Successfully Updated`,
            },
          })

          _this.showOverlay = false
          _this.$router.push('/apps/wallet-networks/networksList')
        }, function (error) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              text: error.message,
              title: `error`,
              variant: 'danger',
            },
          })
          _this.showOverlay = false
        })
      })
    },
  },

  components: {
    MediaHandler,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BOverlay,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
